import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModule } from '@auth0/auth0-angular';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { ValidationService } from './features/arc/services/validation.service';
import { API } from './features/arc/services/api.service';
import { AppData } from './features/arc/services/appdata.service';
import { Global } from './features/arc/services/global.service';
import { ArcAuthService } from './features/arc/services/auth.service';
import { Projects } from './features/arc/services/projects.service';
import { AppBootstrapService } from './features/arc/services/app-bootstrap.service';

import { Config } from './features/arc/components/models/env-vars.model';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,

		AppRoutingModule,

		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			}
		}),

		AuthModule.forRoot({
			domain: Config.auth0_domain,
			clientId: Config.sso_client
		})
	],
	providers: [
		ValidationService,
		API,
		AppData,
		Global,
		ArcAuthService,
		Projects,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ValidationService,
			multi: true
		},
		{
			provide: APP_INITIALIZER,
			useFactory: (configService: AppBootstrapService) => () => configService.load(),
			deps: [AppBootstrapService],
			multi: true
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
